// extracted by mini-css-extract-plugin
module.exports = {"Document":"Document_Document__2kD2b","Document__doc":"Document_Document__doc__Ie2Xx","Delete":"Document_Delete__39r1P","Edit":"Document_Edit__1ohJh"};